import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

type DocPage = {
  title: string;
  href: string;
};

type DocsNavigationProps = {
  previous?: DocPage;
  next?: DocPage;
};

export function DocsNavigation({ previous, next }: DocsNavigationProps) {
  if (!previous && !next) return null;

  return (
    <div className="grid grid-cols-2 gap-4 mt-12 pt-8 border-t border-border">
      {previous ? (
        <Link
          to={previous.href}
          className="flex flex-col gap-1.5 p-4 border border-border rounded-lg hover:bg-accent transition-colors group"
        >
          <span className="text-xs text-muted-foreground">Previous</span>
          <span className="flex items-center gap-2 text-sm font-medium group-hover:text-foreground transition-colors">
            <ChevronLeft className="h-3.5 w-3.5" />
            {previous.title}
          </span>
        </Link>
      ) : (
        <div />
      )}

      {next ? (
        <Link
          to={next.href}
          className="flex flex-col gap-1.5 p-4 border border-border rounded-lg hover:bg-accent transition-colors group text-right"
        >
          <span className="text-xs text-muted-foreground">Next</span>
          <span className="flex items-center justify-end gap-2 text-sm font-medium group-hover:text-foreground transition-colors">
            {next.title}
            <ChevronRight className="h-3.5 w-3.5" />
          </span>
        </Link>
      ) : (
        <div />
      )}
    </div>
  );
}
